<template>
  <div class="install-pwa">
    <div class="install-title"><AutoFontSize v-if="isShow">{{ $t('title_install_bonus') }}</AutoFontSize></div>
    <div class="content">
      <div class="txt-1"><AutoFontSize v-if="isShow">{{ $t('subtitle_install_bonus') }}</AutoFontSize></div>
      <div class="txt-2" v-html="$t('tips_install_bonus', [`<span>${$t('title_install_bonus')}</span>`])"></div>
      <div class="award"></div>
      <template v-if="isComplete">
        <div class="complete"></div>
      </template>
      <template v-else>
        <div v-if="calcShowInstall" class="btn" @click="goInstall">{{ $t('title_install_bonus') }}</div>
        <div v-else class="has-install">{{ $t('boon-browser-forbidden') }}</div>
      </template>
    </div>
  </div>
</template>

<script>
import { ameApiDo } from '@/server/api'
import { mapState } from 'vuex'
export default {
  name: 'InstallPWA',
  props: ['isShow'],
  data () {
    return {
      isComplete: false,
      deferredPrompt: window.__deferredPrompt || undefined
    }
  },
  created () {
    this.$bus.$on('welfare-check-ame-pwa', () => this.init())
    this.init()
  },
  computed: {
    ...mapState({
      userInfo: 'userInfo'
    }),
    calcShowInstall () {
      const result = window.crtDevice
      const { ua } = result

      const whiteBrowser = ua.includes('Chrome') && this.deferredPrompt
      return !!whiteBrowser
    }
  },
  methods: {
    init () {
      const ua = (navigator.userAgent || '').toLowerCase()
      if (ua.includes('chrome')) {
        window.removeEventListener('beforeinstallprompt', this.showPrompt)
        window.addEventListener('beforeinstallprompt', this.showPrompt)
      }
      const params = {
        p0: 'web',
        p1: 18,
        p2: 1106,
        openid: this.userInfo.openid,
        device_id: this.$utils.getDeviceId(),
        source: 'welfares_center'
      }
      ameApiDo(params).then(res => {
        if (res.is_add_desktop || res.is_recevied) {
          this.$emit('setDot', false)
          this.isComplete = true
        } else {
          this.$emit('setDot', true)
          this.isComplete = false
        }
      })
    },
    showPrompt (e) {
      // 防止 Chrome 67 及更早版本自动显示安装提示
      e.preventDefault()
      // 稍后再触发此事件
      this.deferredPrompt = e
    },
    goInstall (type) {
      this.deferredPrompt.prompt()
      // 等待用户反馈
      this.deferredPrompt.userChoice
        .then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            // 本地保存数据，下次进游戏发奖

            // 从奖励弹窗点击安装
            const params = {
              p0: 'web',
              p1: 18,
              p2: 1107,
              openid: this.userInfo.openid,
              device_id: this.$utils.getDeviceId()
            }
            ameApiDo(params)
              .then(res => {
                this.$emit('setDot', false)
                this.isComplete = true
                this.$utils.log('save_to_desktop_reward', { save_channel: 'reward_center' })
              })
              .catch(err => {
                console.error(err)
              })
            this.$utils.log('webgame_shorcut_guide', { type: 'save_shortcut' })
            this.$utils.log('save_to_desktop', { save_channel: 'reward_center' })
          }
        })
    }
  },
  beforeDestroy () {
    window.removeEventListener('beforeinstallprompt', this.showPrompt)
    this.$bus.$off('welfare-check-ame-pwa')
  }
}
</script>

<style lang='scss' scoped >
.install-pwa {
  width: calc(1569 * var(--unit-px));
  height: calc(1023 * var(--unit-px));
  background: url(~@/assets/img/welfare/bg_install_pwa.png) no-repeat center center;
  background-size: 100% 100%;
  position: relative;
}
.install-title {
  position: absolute;
  top: calc(199 * var(--unit-px));
  left: calc(648 * var(--unit-px));
  right: 0;
  font-size: calc(77 * var(--unit-px));
  font-weight: 600;
  color: #FFF5D7;
  line-height: 1.44;
  letter-spacing: 1px;
  text-shadow: 0px 1px 2px #000000;
  .auto-font-size {
    text-align: left;
  }
}
.content {
  position: absolute;
  top: calc(367 * var(--unit-px));
  right: calc(173 * var(--unit-px));
  width: calc(645 * var(--unit-px));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .txt-1 {
    font-size: calc(36 * var(--unit-px));
    line-height: 1.4;
    font-weight: 600;
    color: #FCF163;
    text-shadow: 0px 1px 1px #000000;
    white-space: nowrap;
  }
  .txt-2 {
    font-size: calc(30 * var(--unit-px));
    margin-top: calc(8 * var(--unit-px));
    height: calc(42 * var(--unit-px));
    line-height: 1.4;
    color: #ffffff;
    ::v-deep(span) {
      color: #DA5308;
    }
  }
  .award {
    width: calc(645 * var(--unit-px));
    height: calc(167 * var(--unit-px));
    background: url(~@/assets/img/welfare/award_install_pwa.png) no-repeat center center;
    background-size: 100% 100%;
    margin-top: calc(62 * var(--unit-px));
  }
  .btn {
    width: calc(564 * var(--unit-px));
    height: calc(88 * var(--unit-px));
    background: url(~@/assets/img/welfare/bg_btn.png) no-repeat center center;
    background-size: 100% 100%;
    margin-top: calc(26 * var(--unit-px));
    cursor: pointer;
    line-height: calc(88 * var(--unit-px));
    text-align: center;
    font-size: calc(33 * var(--unit-px));
    font-weight: 600;
    color: #473232;
  }
  .has-install {
    margin-top: calc(27 * var(--unit-px));
    font-size: calc(24 * var(--unit-px));
    line-height: 1.375;
    font-weight: 500;
    color: #FF5E0F;
    text-align: left;
    width: 100%;
    padding-left: calc(30 * var(--unit-px));
    background: url(~@/assets/img/welfare/icon_tips.png) no-repeat;
    background-size: calc(22 * var(--unit-px)) auto;
    background-position: calc(2 * var(--unit-px)) calc(6 * var(--unit-px));
  }
  .complete {
    position: absolute;
    width: calc(349 * var(--unit-px));
    height: calc(264 * var(--unit-px));
    background: url(~@/assets/img/welfare/icon_complete.png) no-repeat center center;
    background-size: 100% 100%;
    top: calc(231 * var(--unit-px));
    right: calc(-94 * var(--unit-px));
  }
}
</style>
